import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import { PanelConfigurationIndicators } from '../model/configuration/panelConfigurationIndicators.model';
declare var jquery: any;
declare var $: any;
import { Indicator, IndicatorType } from '../model/report/indicator.model';

@Component({
  selector: 'app-grouping',
  templateUrl: './grouping.component.html',
  styleUrls: ['./grouping.component.css']
})
export class GroupingComponent implements OnInit {

  doughnutChart: DoughnutChart;
  doughnutCharts: Array<DoughnutChart>;
  panelConfigurationIndicators: PanelConfigurationIndicators;
  indicatorsItems: Array<Indicator>;
  indicatorType: typeof IndicatorType = IndicatorType;

  private _indicators;

  @Input() groupingName;
  @Input()
  set indicators(indicators: Array<Indicator>) {
    this._indicators = indicators;
    this.prepareDoughnutCharts();
  }
  @Input()
  set painel(painel: PanelConfigurationIndicators) {
    this.panelConfigurationIndicators = painel;
  }
  @Input() searchRecycle;

  constructor() { }

  ngOnInit() {
  }

  prepareDoughnutCharts() {
     // debugger;
    this.doughnutCharts = new Array<DoughnutChart>();

    if (this._indicators.length < 3) {
      this.adjustEmptyIndicators();
    }

    for (const indicator of this._indicators) {

      this.doughnutChart = new DoughnutChart();
      this.doughnutChart.doughnutChartData = [indicator.onTarget, indicator.offTarget];
      this.doughnutChart.indicatorType = indicator.type;
      this.doughnutCharts.push(this.doughnutChart);

    }

    $('.connectedSortable').sortable({
      placeholder: 'sort-highlight',
      connectWith: '.connectedSortable',
      handle: '.box-header, .nav-tabs',
      forcePlaceholderSize: true,
      zIndex: 999999
    });

    $('.connectedSortable .box-header, .connectedSortable .nav-tabs-custom').css('cursor', 'move');

    if (this.groupingName == undefined)
      this.groupingName = 'Não tem agrupamento';

    this.indicatorsItems = this._indicators;
  }

  getDoughnutData(type: number): DoughnutChart {

    return this.doughnutCharts.find(x => x.indicatorType === type);
  }

  adjustEmptyIndicators() {
    let indList = [];
    let result = this._indicators.find(i => i.type == 1);
    if (!result) {
      indList[0] = this.createEmptyIndicator(1);
    } else {
      indList[0] = result;
    }
    result = this._indicators.find(i => i.type == 2);
    if (!result) {
      // this._indicators.push(this.createEmptyIndicator(2));
      indList[1] = this.createEmptyIndicator(2);
    } else {
      indList[1] = result;
    }
    result = this._indicators.find(i => i.type == 3);
    if (!result) {
      // this._indicators.push(this.createEmptyIndicator(3));
      indList[2] = this.createEmptyIndicator(3);
    } else {
      indList[2] = result;
    }
    this._indicators = indList;
  }

  createEmptyIndicator(type: number) {
    let ind = new Indicator();
    ind.type = type;
    ind.total = 0;
    ind.average = '00:00:00';
    ind.offTarget = 0;
    ind.onTarget = 0;
    ind.percOffTarget = 0;
    ind.percOnTarget = 0;
    return ind;
  }
}

export class DoughnutChart {

  doughnutChartType: string;
  doughnutChartLabels: string[] = ['Dentro do SLA', 'Fora do SLA'];
  doughnutChartData: number[];
  indicatorType: number;
  doughnutChartOptions = { legend: { display: false }, tooltips: { enabled: true } };
  doughnutChartColors = [{ backgroundColor: ['#00a65a', '#E14025'], borderColor: ['#00a65a', '#E14025'], borderWidth: [0, 0] }];

  constructor() { this.doughnutChartType = 'doughnut'; }
}
